

import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminTaskService} from '../../../../services/api/admin/task-service-api/task-service-api.service';
import {AdminTaskListsComponentDialog} from './admin-task-lists-create-edit-dialog/admin-task-lists-create-edit-dialog.component';
import {ModalConfirmationComponent} from '../../../../shared/modal-confirmation/modal-confirmation.component';
import {DialogService} from '../../../../services/dialog-service/dialog.service';

@Component({
  selector: 'app-admin-task-lists',
  templateUrl: './admin-task-lists.html'
})
export class AdminTaskListsComponent implements OnInit {

  data;
  isLoading = true;

  constructor(private apiAdminTaskService: ApiAdminTaskService, private dialogService: DialogService, private viewReference: ViewContainerRef) {
    this.getData();
  }

  ngOnInit(): void {
  }

  getData(){
    this.isLoading = true;
    this.apiAdminTaskService.listAll().then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminTaskListsComponentDialog, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  edit(id){
    // Replace null with Component
    this.dialogService.createDialog(AdminTaskListsComponentDialog, id, this.viewReference)
      .then(dialogSaved => {
        this.getData();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminTaskService.delete(id).then(response => this.getData())
      }, cancelled => null)
  }



}
